// Device data collection is a short background exchange with the issuer's provider; it is not
// waiting on the buyer, so it fails fast instead of holding the checkout.
export const MALGA_COLLECTION_TIMEOUT_MS = 10000;

// The challenge waits on the buyer, who has to receive and type a code, so it waits about as long as
// the issuer keeps the session open. Past it, the transaction is left to expire on Malga's side.
export const MALGA_CHALLENGE_TIMEOUT_MS = 10 * 60 * 1000;

// The modal holding the frame is mounted by the same store update that starts the challenge
export const MALGA_CHALLENGE_CONTAINER_ID = 'malgaChallengeContainer';
export const MALGA_CHALLENGE_CONTAINER_TIMEOUT_MS = 2000;

// What the buyer API return page posts once the issuer sends the frame back
export const EXTERNAL_AUTHENTICATION_RETURN_MESSAGE = 'planne:externalAuthenticationReturn';
